import axios from "axios";
import React, { useEffect, useState } from "react";
import { BASE_URL } from "../../utils/Constants";
import Swal from "sweetalert2";
import { NavLink, useNavigate, useSearchParams } from "react-router-dom";



const UserContent = () => {

    const [searchParams, setSearchParams] = useSearchParams();
    let id: any = searchParams.get("id");
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        id: "",
        email: "",
        password: "",
        displayname: "",
        role_id: 2,
    });
    const handleAddUser = (e: any) => {
        e.preventDefault();
        axios.post(`${BASE_URL}/users/adduser.php`, formData).then((res) => {
            Swal.fire("Success", "User added successfully", "success").then(() => {
                navigate(`/assgingcourse?id=${res.data.data.id}`);
            })
        }).catch((err) => {
            Swal.fire("Error",err.response.data.msg , "error")
        })
    }

    useEffect(() => {
        if (id != 0) {

            axios.get(`${BASE_URL}/users/getuser.php?id=${id}`).then((res) => {
                setFormData(res.data.data)
            })
        }
    }, [])

    const handleChange = (e: any) => {
        const name = e.target.name;
        const value = e.target.value;
        setFormData((prevState: any) => ({ ...prevState, [name]: value }));
    };
    return (
        <div>
            <NavLink to={"/users"} className="btn btn-secondary"><i className="bi bi-arrow-left" style={{color:"white"}}></i></NavLink>
            <h2>Add user </h2>
            <form onSubmit={handleAddUser}>
                <div className="mb-3">
                    <label htmlFor="exampleInputEmail1" className="form-label">Email </label>
                    <input type="email" name="email" value={formData.email} onChange={handleChange} className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" />

                </div>
                <div className="mb-3">
                    <label htmlFor="exampleInputPassword1" className="form-label">Password</label>
                    <input type="text" name="password" value={formData.password} onChange={handleChange} className="form-control" id="exampleInputPassword1" />
                </div>
                <div className="mb-3">
                    <label htmlFor="displayname" className="form-label">Display name </label>
                    <input type="text" name="displayname" value={formData.displayname} onChange={handleChange} className="form-control" id="displayname" />
                </div>
                <div className="mb-3">
                <label htmlFor="role" className="form-label">Role </label>

                    <select className="form-select" name="role_id" onChange={handleChange}  aria-label="Default select example">
                       
                       
                        <option value="2" selected={formData.role_id == 2}>Student</option>
                        <option value="1" selected={formData.role_id == 1}>Admin</option>
                       
                    </select>
                </div>
<div className="text-center">

                <button className="btn btn-success" >Submit</button>
</div>
            </form>
        </div>
    )
}


export default UserContent